<div class="ajax-loading ajax-popup-loading"><div class="loading-icon"></div></div>
<div class="mat-dialog-title" mat-dialog-title="">
    <h2>{{video.id != null && video.id.length > 0 ? "Edit Video" : "Add Video"}}</h2>
    <button mat-button mat-dialog-close class="close">Cancel</button>
</div>
<form (ngSubmit)="saveVideo()">
    <div mat-dialog-content class="example-container">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <mat-label>Video Category <span class="required">*</span></mat-label>
                    <mat-form-field>
                        <mat-select [formControl]="category" placeholder="Select a video category" [(ngModel)]="video.category" (selectionChange)="categoryChange()">
                            <mat-option *ngFor="let videoCategory of videoCategoryEnum" [value]="videoCategory">{{ videoCategory }}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="category.invalid">Category is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <mat-label>Auto Purge <span class="required">*</span></mat-label>
                    <mat-form-field>
                        <input matInput type="number" placeholder="Auto Purge"
                                [formControl]="autoPurge" name="autoPurge" [(ngModel)]="video.autoPurge" />
                        <mat-error *ngIf="autoPurge.invalid">Auto purge is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6" *ngIf="video.category === videoCategorys.StationSpecific">
                <div class="form-group">
                    <mat-label>Station <span class="required">*</span></mat-label>
                    <mat-form-field>
                        <input
                            type="text"
                            matInput
                            placeholder="Select station"
                            [formControl]="station"
                            [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayStation">
                            <mat-option *ngFor="let station of filteredStation | async" [value]="station">
                            {{  station.crsCode + ' - ' + station.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <!-- <mat-select [formControl]="station" placeholder="Select a station" [(ngModel)]="video.stationId">
                            <mat-option *ngFor="let station of stationList" [value]="station.id">{{ station.crsCode + ' - ' + station.name }}</mat-option>
                        </mat-select> -->
                        <mat-error *ngIf="station.invalid">Station is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6" *ngIf="video.category === videoCategorys.StationSpecific">
                <div class="form-group">
                    <mat-label>Video Type <span class="required">*</span></mat-label>
                    <mat-form-field>
                        <mat-select [formControl]="videoType" placeholder="Select a station" [(ngModel)]="video.type">
                            <mat-option *ngFor="let type of videoTypeEnum" [value]="type">{{ type }}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="videoType.invalid">Video type is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6" *ngIf="video.category === videoCategorys.StationSpecific">
                <div class="form-group">
                    <mat-label>Via</mat-label>
                    <mat-form-field>
                        <input matInput type="text" placeholder="Via"
                                [formControl]="via" name="via" [(ngModel)]="video.via" />
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6" *ngIf="video.category === videoCategorys.Cancel || video.category === videoCategorys.Delay">
                <div class="form-group">
                    <mat-label>{{video.category}} Code <span class="required">*</span></mat-label>
                    <mat-form-field>
                        <input matInput type="text" placeholder="{{video.category}} Code"
                                [formControl]="videoCode" name="videoCode" [(ngModel)]="video.code" />
                        <mat-error *ngIf="videoCode.invalid">{{video.category}} Code is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6" *ngIf="video.category === videoCategorys.Cancel || video.category === videoCategorys.Delay">
                <div class="form-group">
                    <mat-label>{{video.category}} Reason<span class="required">*</span></mat-label>
                    <mat-form-field>
                        <textarea matInput placeholder="{{video.category}} Reason" [formControl]="codeDescription" name="codeDescription" [(ngModel)]="video.codeDescription" rows="2"></textarea>
                        <mat-error *ngIf="codeDescription.invalid">{{video.category}} Reason is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    
                </div>
            </div>
            <div class="col-md-12">
                <mat-card class="mt-3 p-0">
                    <div class="upload-container m-3"
                        (drop)="onDrop($event)"
                        (dragover)="onDragOver($event)"
                        (dragleave)="onDragLeave($event)"
                        [class.dragover]="isDragOver"
                        *ngIf="!isFileDownload">
                        <div class="d-flex flex-wrap justify-content-center">
                            Drag & drop file or click to
                            <input type="file" #fileInput (change)="onFileSelected($event)" hidden accept="video/mp4">
                            <button type="button" (click)="fileInput.click()">Browse </button>
                        </div>
                        <span class="file-limit">Supported Format : MP4 (max.100 MB each)</span>
                    </div>


                    <div class="upload-list" *ngIf="video.fileName">
                        <div class="upload-title">
                            <div>Uploaded File </div>
                            <div>Action</div>
                        </div>
                        
                        <ul>
                            <li>
                                <div>{{ video.fileName }}</div>
                                <div>
                                    <div class="upload-actions">
                                        <button type="button" (click)="downloadFile()" *ngIf="isFileDownload">
                                        <i class="material-icons">download</i>
                                        <!-- <img src="./assets/images/icon-dropdown.svg" alt=""> -->
                                        </button>
                                        <button type="button" (click)="removeFile()">
                                            <img src="./assets/images/icon-delete.svg" alt="">
                                        </button>
                                    </div>
                                    
                                </div>
                            </li>
                        </ul>
                    </div>
                </mat-card>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="row">
        <div class="col-12">
            <div class="text-center py-3 d-flex  justify-content-center"> 
                <button mat-raised-button color="primary" (click)="closeDialog()" type="button" class="btn-outline-black me-3">Cancel </button>
                <button mat-raised-button color="primary" type="submit" class=" btn-black ">Save </button>&nbsp;&nbsp;                
            </div>
        </div>
    </div>
</form>






